import * as process from "node:process";
import { type CountryCode } from "./i18n";

const env = import.meta?.env ? import.meta.env : process.env;

export const IS_DEV = env.DEV;

export const API_URL = env.VITE_API_URL ?? "";
export const STATUS_API_URL = env.VITE_STATUS_API_URL ?? "";
export const TRANSLATIONS_API_URL = env.VITE_TRANSLATIONS_API_URL ?? "";
export const BUDGET_API_URL = env.VITE_BUDGET_API_URL ?? "";
export const CUSTOMER_STORAGE_API_URL = env.VITE_CUSTOMER_STORAGE_API_URL ?? "";
export const CUSTOMER_SCREENING_API_URL =
  env.VITE_CUSTOMER_SCREENING_API_URL ?? "";
export const CMS_URL = env.VITE_CMS_URL ?? "";
export const CMS_API_URL = env.VITE_CMS_API_URL ?? "";
export const CUSTOMER_BANK_CONSENT_LEDGER_API_URL =
  env.VITE_CUSTOMER_BANK_CONSENT_LEDGER_API_URL ?? "";
export const CUSTOMER_DEBT_API_URL = env.VITE_CUSTOMER_DEBT_API_URL ?? "";

export const COUNTRY_CODE = env.VITE_COUNTRY_CODE as CountryCode;

export const AVAILABLE_LANGUAGES = env.VITE_AVAILABLE_LANGUAGES ?? "";

export const APP_VERSION = env.VITE_APP_VERSION ?? "";

export const TAWK_TO_PROPERTY_ID = env.VITE_TAWK_TO_PROPERTY_ID ?? "";
export const TAWK_TO_WIDGET_ID = env.VITE_TAWK_TO_WIDGET_ID ?? "";

export const FACEBOOK_APP_ID = env.VITE_FACEBOOK_APP_ID ?? "";
export const FACEBOOK_SCRIPT_URL = "/scripts/facebookSDK.js";
export const FACEBOOK_SDK_VERSION = "v19.0";

export const APPLE_CLIENT_ID = env.VITE_APPLE_CLIENT_ID ?? "";
export const APPLE_REDIRECT_URI = env.VITE_APPLE_REDIRECT_URI ?? "";
export const APPLE_SCRIPT_URL =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

export const ACCOUNT_SCORING_SCRIPT_URL =
  "https://accountscoring.com/static/asc-embed-v2.js";

export const SENTRY_DSN = env.VITE_SENTRY_DSN ?? "";

export const GA4_ID = env.VITE_GA4_ID ?? "";
export const GTM_ID = env.VITE_GTM_ID ?? "";

export const RECAPTCHA_SITE_KEY = env.VITE_RECAPTCHA_SITE_KEY ?? "";

export const IS_TESTING_ENV = env.VITE_IS_TESTING_ENV as boolean;

export const DOCUMENT_VIEWER_LICENSE_KEY =
  env.VITE_DOCUMENT_VIEWER_LICENSE_KEY ?? "";

export const JQUERY_SCRIPT_URL =
  "https://code.jquery.com/jquery-3.7.1.slim.min.js";
export const DOKOBIT_SCRIPT_URL =
  "https://gateway.dokobit.com/js/isign.frame.js";

export const DEFAULT_CURRENCY_SETTINGS: { locale: string; currency: string } = {
  lt: {
    locale: "lt-LT",
    currency: "EUR",
  },
  ee: {
    locale: "et-EE",
    currency: "EUR",
  },
  pl: {
    locale: "pl-PL",
    currency: "PLN",
  },
}[COUNTRY_CODE];

export const IS_MK_DEBT_MODE =
  typeof VITE_IS_MK_DEBT_MODE !== "undefined" && VITE_IS_MK_DEBT_MODE;

export const IS_APP_KYC_MODE =
  typeof VITE_IS_APP_KYC_MODE !== "undefined" && VITE_IS_APP_KYC_MODE;

export const RECAPTCHA_HEADER_NAME = "X-ReCaptcha-Token";
